document.addEventListener(
  "DOMContentLoaded",
  async function () {

    const checkout =
      document.getElementById(
        "amhuk-checkout"
      );

    if (!checkout) return;


    let paymentMethod =
      "prepaid";


    /*
    ============================================
    GET SHOPIFY CART
    ============================================
    */

    async function getCart() {

      const response =
        await fetch(
          "/cart.js"
        );

      return await response.json();

    }


    /*
    ============================================
    CALCULATE
    ============================================
    */

    function calculate(
      amount,
      method
    ) {

      if (
        method === "prepaid"
      ) {

        const discount =
          amount * 0.10;

        return {

          adjustment:
            discount,

          total:
            amount - discount

        };

      }


      const codCharge =
        amount * 0.15;

      return {

        adjustment:
          codCharge,

        total:
          amount + codCharge

      };

    }


    /*
    ============================================
    UPDATE UI
    ============================================
    */

    async function updateCheckout() {

      const cart =
        await getCart();


      /*
      Shopify money is in cents
      */

      const base =
        cart.total_price / 100;


      const prepaid =
        calculate(
          base,
          "prepaid"
        );


      const cod =
        calculate(
          base,
          "cod"
        );


      document
        .getElementById(
          "amhuk-prepaid-total"
        )
        .textContent =
        `AED ${prepaid.total.toFixed(2)}`;


      document
        .getElementById(
          "amhuk-cod-total"
        )
        .textContent =
        `AED ${cod.total.toFixed(2)}`;


      const current =
        calculate(
          base,
          paymentMethod
        );


      document
        .getElementById(
          "amhuk-final-total"
        )
        .textContent =
        `AED ${current.total.toFixed(2)}`;


      if (
        paymentMethod ===
        "prepaid"
      ) {

        document
          .getElementById(
            "amhuk-adjustment-label"
          )
          .textContent =
          "Prepaid Discount (10%)";


        document
          .getElementById(
            "amhuk-adjustment"
          )
          .textContent =
          `- AED ${current.adjustment.toFixed(2)}`;

      } else {

        document
          .getElementById(
            "amhuk-adjustment-label"
          )
          .textContent =
          "COD Charge (15%)";


        document
          .getElementById(
            "amhuk-adjustment"
          )
          .textContent =
          `+ AED ${current.adjustment.toFixed(2)}`;

      }

    }


    /*
    ============================================
    PAYMENT METHOD
    ============================================
    */

    document
      .querySelectorAll(
        ".amhuk-payment"
      )
      .forEach(
        function (button) {

          button.addEventListener(
            "click",
            function () {

              paymentMethod =
                this.dataset
                  .paymentMethod;


              document
                .querySelectorAll(
                  ".amhuk-payment"
                )
                .forEach(
                  btn =>
                    btn.classList.remove(
                      "active"
                    )
                );


              this.classList.add(
                "active"
              );


              updateCheckout();

            }
          );

        }
      );


    /*
    ============================================
    CONTINUE
    ============================================
    */

    document
      .getElementById(
        "amhuk-pay-button"
      )
      .addEventListener(
        "click",
        async function () {


          const cart =
            await getCart();


          const baseAmount =
            cart.total_price / 100;


          const firstName =
            document
              .getElementById(
                "amhuk-first-name"
              )
              .value;


          const lastName =
            document
              .getElementById(
                "amhuk-last-name"
              )
              .value;


          const email =
            document
              .getElementById(
                "amhuk-email"
              )
              .value;


          if (
            !firstName ||
            !lastName ||
            !email
          ) {

            document
              .getElementById(
                "amhuk-message"
              )
              .textContent =
              "Please complete your details.";

            return;

          }


          /*
          ========================================
          COD
          ========================================
          */

          if (
            paymentMethod ===
            "cod"
          ) {

            const quote =
              calculate(
                baseAmount,
                "cod"
              );


            document
              .getElementById(
                "amhuk-message"
              )
              .textContent =

              `COD Total: AED ${quote.total.toFixed(2)}`;

            /*
            IMPORTANT:
            Yahan Shopify COD order
            creation backend connect karna hai.
            */

            return;

          }


          /*
          ========================================
          PREPAID
          ========================================
          */

          const orderReference =
            "AMHUK-" +
            Date.now();


          this.disabled =
            true;


          this.textContent =
            "Creating Payment...";


          try {


            const response =
              await fetch(
                "https://YOUR-BACKEND-DOMAIN.com/api/mamo/create-payment",
                {

                  method:
                    "POST",

                  headers: {

                    "Content-Type":
                      "application/json"

                  },

                  body:
                    JSON.stringify({

                      baseAmount,

                      email,

                      firstName,

                      lastName,

                      orderReference

                    })

                }
              );


            const data =
              await response.json();


            if (
              !response.ok
            ) {

              throw new Error(
                data.error ||
                "Payment failed"
              );

            }


            /*
            MAMO INLINE CHECKOUT
            */

            const mamoPay =
              new MamoPay();


            document
              .getElementById(
                "amhuk-mamo-container"
              )
              .style.display =
              "block";


            mamoPay.addIframeToWebsite(

              "mamo-checkout-element",

              data.paymentLink

            );


            this.style.display =
              "none";


          } catch (
            error
          ) {


            document
              .getElementById(
                "amhuk-message"
              )
              .textContent =
              error.message;


            this.disabled =
              false;


            this.textContent =
              "Continue to Payment";

          }

        }
      );


    updateCheckout();

  }
);